import { render, staticRenderFns } from "./CardPage.vue?vue&type=template&id=1068ca87&"
import script from "./CardPage.vue?vue&type=script&lang=js&"
export * from "./CardPage.vue?vue&type=script&lang=js&"
import style0 from "./CardPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports